<template>
  <Row id="Attendance">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.AttendanceManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.search')" name="search">
                  <Input :placeholder="$t('attendance.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.dateRange')" name="dateRange">
                  <RangePicker :allowClear="false" v-model:value="rangePickerDate" @change="rangeChange"/>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.department')" name="department">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idDep"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['departmentList']" :value="item['idDep']">{{ item['name'] }}</SelectOption>
                      </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.late')">
                  <Select v-model:value="searchForm.late">
                    <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.name.yes') }}</SelectOption>
                    <SelectOption :value="0">{{ $t('public.name.no') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.earlyLeave')">
                  <Select v-model:value="searchForm.earlyLeave">
                    <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.name.yes') }}</SelectOption>
                    <SelectOption :value="0">{{ $t('public.name.no') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idAtt" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('AttendanceManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text}">
              <div>
                <!-- <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('AttendanceManage.Edit')" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('AttendanceManage.Delete')" type="primary" danger size="small" @click="del(text.idAtt)">{{$t("public.name.del")}}</Button>
                </div> -->
                <Dropdown :trigger="['click']">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="detail(text)">{{$t("public.name.detail")}}</MenuItem>
                      <MenuItem v-if="checkPermission('AttendanceManage.Edit')" @click="edit(text)">{{$t("public.name.edit")}}</MenuItem>
                      <MenuItem v-if="checkPermission('AttendanceManage.Delete')" danger @click="del(text.idAtt)">{{$t("public.name.del")}}</MenuItem>
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <AttendanceDetail ref="refAttendanceDetail"></AttendanceDetail>
    <AttendanceEdit ref="refAttendanceEdit" @updateList="get_list"></AttendanceEdit>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message, RangePicker } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { AttendanceList } from "@/api/AttendanceList";
import { AttendanceDelete } from "@/api/AttendanceDelete"
import { DepartmentListAll } from "@/api/DepartmentListAll";
import AttendanceDetail from "@/components/Home/AttendanceDetail";
import AttendanceEdit from "@/components/Home/AttendanceEdit";
import moment from "moment";

export default {
  name: "AttendanceManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    AttendanceDetail,
    AttendanceEdit,
    RangePicker,
  },
  data() {
    return {
      rangePickerDate:[],
      searchForm: {
        search: "",
        startDate: null,
        endDate: null,
        idDep: null,
        late:null,
        earlyLeave:null
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          { title: this.$t("attendance.table.id_att"), fixed: "left", dataIndex: "idAtt", key: "idAtt" },
          { title: this.$t("attendance.table.id_emp"), dataIndex: "employeeNickName", key: "employeeNickName" },
          { title: this.$t("attendance.table.check_in"), dataIndex: "checkIn", key: "checkIn", customRender: ({text}) =>{
            if(text){
              return moment(text).format('YYYY-MM-DD HH:mm:ss')
            }else{
              return ''
            }
            
            }},
          { title: this.$t("attendance.table.check_out"), dataIndex: "checkOut", key: "checkOut", customRender: ({text}) =>{
            if(text){
              return moment(text).format('YYYY-MM-DD HH:mm:ss')
            }else{
              return ''
            }

            
            }},
          { title: this.$t("attendance.table.late"), dataIndex: "late", key: "late", customRender: ({text}) =>{
              if(text != null)
                return this.selectList.booleanList.find(item=>item.value===text).label
              
              
            }
          },
          { title: this.$t("attendance.table.early_leave"), dataIndex: "earlyLeave", key: "earlyLeave", customRender: ({text,record}) =>{
              if(text != null){
                return this.selectList.booleanList.find(item=>item.value===text).label
              }
              else{
                //如果是沒有打卡記錄，則要判定今天是否已過，如果今天已過，則顯示缺卡
                let days = moment(record.checkIn, 'YYYY-MM-DD 00:00:00').add(1,'days').diff(moment(),'days')
                if(days < 0) {
                  return '缺卡'
                }
                
              }
              
              
            }
          },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
        employeeList: [],
        departmentList: [],
        booleanList:[{value: false,label: '否'},{value: true,label: '是'}],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new AttendanceList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      if (this.searchForm.startDate != "") getData.startDate = this.searchForm.startDate
      if (this.searchForm.endDate != "") getData.endDate = this.searchForm.endDate
      if (this.searchForm.idDep != "") getData.idDep = this.searchForm.idDep
      if (this.searchForm.late === 0 || this.searchForm.late === 1) getData.late = this.searchForm.late
      if (this.searchForm.earlyLeave === 0 || this.searchForm.earlyLeave === 1) getData.earlyLeave = this.searchForm.earlyLeave
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
            //如果當前處於不是第一頁，但是又沒有數據的情況，則把頁面設置為1，並重新請求
            if(this.list.length == 0 && this.tablePagination.current != 1){
              this.tablePagination.current = 1;
              this.get_list();
            }
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refAttendanceEdit.addShow();
    },
    detail(obj) {
      this.$refs.refAttendanceDetail.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refAttendanceEdit.editShow(obj);
    },
    del(idAtt) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new AttendanceDelete();
          api.post({ idAtt: idAtt }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    rangeChange(dates){
      this.searchForm.startDate = dates[0].format("YYYY-MM-DD")
      this.searchForm.endDate = dates[1].format("YYYY-MM-DD")
    },
    getDepartmentList() {
      const api = new DepartmentListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
          this.selectList.departmentList = response.data.data;
        } else {
          message.error(response.data.msg);
        }
      });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.rangePickerDate = [null,null];
      this.searchForm = {
        search: "",
        startDate: null,
        endDate: null,
        idDep: null,
        late:null,
        earlyLeave:null
      }
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
    this.getDepartmentList();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/attendance.less");
</style>